export { default } from "./src/collection-pricing-hero";

export type { UniformCollectionPricingHeroProps } from "./src/collection-pricing-hero";
